export default {
  name: 'dn-navigation-paging',

  props: {
    category: {
      type: String,
      required: true,
    },
    group: {
      type: String,
      required: true,
    },
  },

  computed: {
    computedGroup() {
      return this.$store.getters['navigation/categoryGroup'](this.category, this.group);
    },
  },

  methods: {
    genLink(link, type, h = this.$createElement) {
      const tag = link ? 'a' : 'span';
      const attrs = link ? {
        href: link.href,
      } : undefined;

      if (link && link.target) {
        attrs.target = link.target;
      }

      const typeName = type === 'prev' ? '前の' : '次の';
      const children = link ? [
        h('span', {
          staticClass: 'dn-navigation-paging__link__ttl',
          domProps: {
            innerHTML: '<span class="dn-navigation-paging__link__ttl__inner">' + typeName + '<br>ページ</span>',
          },
        }),
        h('span', {
          staticClass: 'dn-navigation-paging__link__label',
        }, [h('span', {
          staticClass: 'dn-navigation-paging__link__label__box',
        }, [
          h('span', {
            staticClass: 'dn-navigation-paging__link__label__box__inner',
          }, [
            h('span', {
              // domProps: {
              //   innerHTML: link.label.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, ''),
              // },
              directives: [{
                name: 'line-clamp',
                value: {
                  lines: 2,
                  text: link.label.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, ''),
                },
              }],
            })
          ])
        ])]),
        h('i', {
          staticClass: 'dn-navigation-paging__link__tri',
        }),
      ] : undefined;

      return h(tag, {
        staticClass: 'dn-navigation-paging__link',
        class: {
          ['dn-navigation-paging__link--' + type]: true,
        },
        attrs,
        style: {
          visibility: link ? 'visible' : 'hidden',
        },
        key: type,
      }, children);
    },
  },

  render(h) {
    const group = this.computedGroup;
    if (!group) return;

    const current = group.links.find(l => l.matched);
    if (!current) return;

    const currentIndex = group.links.indexOf(current);
    let prev = group.links[currentIndex - 1];
    let next = group.links[currentIndex + 1];
    prev = (prev && !prev.data.groupIndex && prev.data.groupIndex !== '') ? prev : null;
    next = (next && !next.data.groupIndex && next.data.groupIndex !== '') ? next : null;

    if (!prev && !next) return;

    return h('nav', {
      staticClass: 'dn-navigation-paging',
    }, [
      this.genLink(prev, 'prev'),
      this.genLink(next, 'next'),
    ]);
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/navigations/NavigationPaging.js